<template>
    <el-dialog title="거래처 추가" v-model="visible" width="50%">
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="120px">
        <el-form-item label="거래처명" prop="name">
          <el-input v-model="formData.name" placeholder="거래처명을 입력하세요" />
        </el-form-item>
        <el-form-item label="사업자등록번호" prop="business_number">
          <el-input v-model="formData.business_number" placeholder="사업자등록번호를 입력하세요" />
        </el-form-item>
        <el-form-item label="대표자명" prop="representative_name">
          <el-input v-model="formData.representative_name" placeholder="대표자명을 입력하세요" />
        </el-form-item>
        <el-form-item label="거래은행" prop="bank">
          <el-input v-model="formData.bank" placeholder="거래은행을 입력하세요" />
        </el-form-item>
        <el-form-item label="계좌번호" prop="account_number">
          <el-input v-model="formData.account_number" placeholder="계좌번호를 입력하세요" />
        </el-form-item>
        <el-form-item label="예금주" prop="account_holder">
          <el-input v-model="formData.account_holder" placeholder="예금주를 입력하세요" />
        </el-form-item>

        <el-form-item label="전화번호" prop="phone">
          <el-input v-model="formData.phone" placeholder="전화번호를 입력하세요" />
        </el-form-item>

        <el-form-item label="영문명" prop="english_name">
          <el-input v-model="formData.english_name" placeholder="영문명을 입력하세요" />
        </el-form-item>
        <el-form-item label="국가" prop="country">
          <el-input v-model="formData.country" placeholder="국가를 입력하세요" />
        </el-form-item>
        <el-form-item label="영문국가" prop="english_country">
          <el-input v-model="formData.english_country" placeholder="영문문국가를 입력하세요" />
        </el-form-item>
        <el-form-item label="주소" prop="address">
          <el-input v-model="formData.address" placeholder="주소를 입력하세요" />
        </el-form-item>
        <el-form-item label="영문주소" prop="english_address">
          <el-input v-model="formData.english_address" placeholder="영문주소를 입력하세요" />
        </el-form-item>
        
        <el-form-item label="주민등록번호" prop="personal_id">
          <el-input v-model="formData.personal_id" placeholder="주민등록번호를 입력하세요" />
        </el-form-item>
        <el-form-item label="공급사구분" prop="category">
          <el-input v-model="formData.category" placeholder="공급사구분을 입력하세요" />
          <SupplierCategorySelect v-model="formData.supplierCategory"/>
        </el-form-item>      
        
        <el-form-item label="FAX번호" prop="fax">
          <el-input v-model="formData.fax" placeholder="FAX번호를 입력하세요" />
        </el-form-item>
        <el-form-item label="이메일" prop="email">
          <el-input v-model="formData.email" placeholder="이메일을 입력하세요" />
        </el-form-item>
      </el-form>
  
      <template #footer>
        <el-button @click="closeModal">취소</el-button>
        <el-button type="primary" @click="saveVendor">저장</el-button>
      </template>
    </el-dialog>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import axiosInstance from '@/api/axios';
  import SupplierCategorySelect from '@/components/SupplierCategorySelect.vue';

  const emits = defineEmits(['close']);


  const visible = ref(true);
  const formData = ref({
    name: '',
    business_number: '',
    representative_name: '',
    bank:'',
    account_number: '',
    account_holder: '',
    phone:'',
    english_name:'',
    country:'',
    english_country:'',
    address:'',
    english_address:'',
    personal_id:'',
    email: '',
    supplierCategory:'',
    fax:'',
   
  
  });
  
  const rules = {
    name: [{ required: true, message: '공급사명을 입력하세요.', trigger: 'blur' }],
    business_number: [{ required: true, message: '사업자등록번호를 입력하세요.', trigger: 'blur' }],
    representative_name: [{ required: true, message: '대표자명을 입력하세요.', trigger: 'blur' }],
    account_number: [{ required: true, message: '계좌번호를  입력하세요.', trigger: 'blur' }],
    account_holder: [{ required: true, message: '예금주를  입력하세요.', trigger: 'blur' }],
    phone: [{ required: true, message: '전화번호  입력하세요.', trigger: 'blur' }],
    bank: [{ required: true, message: '거래은행을  입력하세요.', trigger: 'blur' }],
  };
  
  // 모달 닫기
  const closeModal = () => {
    visible.value = false;
    emits('close');

  };
  
  // 거래처 저장
  const saveVendor = async () => {
    console.log('저장된 거래처:', formData.value);
    
    await axiosInstance.post('suppliers/',formData.value);

    // 상위 컴포넌트로 이벤트 전달
    //emit('vendor-added', formData.value);
    closeModal();
  };
  </script>
  